import { atomWithReset } from 'jotai/utils'

import { type Unassigned } from '~/utils'

import { type SurveyGroup } from './hooks/useMainQuery'

type DialogInfo =
  | {
      dialogType:
        | 'brandSettings'
        | 'customerAttributeGroupSettings'
        | 'delete'
        | 'questionSettings'
        | 'surveySettings'
        | 'update'
      surveyGroup: SurveyGroup
    }
  | {
      dialogType: 'create'
      surveyGroup?: null
    }

export const dialogInfoAtom = atomWithReset<DialogInfo | null>(null)

type LinkAnswersInfo = {
  index: number
  question: {
    id?: string
    name: string
    attachedQuestionMap: Record<string, Unassigned | string | null>
    options: {
      id?: string
      text: string
      attachedOptionMap: Record<string, Unassigned | number | null>
    }[]
  }
}

export const linkAnswersInfoAtom = atomWithReset<LinkAnswersInfo | null>(null)

type LinkCustomerAttributesInfo = {
  index: number
  customerAttributeGroup: {
    id?: string
    name: string
    attachedCustomerAttributeGroupMap: Record<
      string,
      Unassigned | string | null
    >
    customerAttributes: {
      id?: string
      name: string
      attachedCustomerAttributeMap: Record<string, Unassigned | number | null>
    }[]
  }
}

export const linkCustomerAttributesInfoAtom =
  atomWithReset<LinkCustomerAttributesInfo | null>(null)
